import { useEffect, useRef } from 'react';
import { usePermissions } from '../context/PermissionsContext';
import { useSnackbar } from './SnackbarContext';

// Surfaces the "last logged in from..." notice (pentest SQ280526-02,
// finding #1) once per browser tab. The API only ever sends previousLogin
// once (it self-clears the field after the first /user-permissions read),
// but this guard also protects against duplicate renders/effects.
const LastLoginNotice = () => {
  const { previousLogin } = usePermissions();
  const { showSnackbar } = useSnackbar();
  const shown = useRef(false);

  useEffect(() => {
    if (!previousLogin || shown.current) {
      return;
    }
    shown.current = true;
    const when = new Date(previousLogin.time).toLocaleString();
    const from = previousLogin.ip ? ` from ${previousLogin.ip}` : '';
    showSnackbar(`Last login: ${when}${from}`, 'info', 'top');
  }, [previousLogin, showSnackbar]);

  return null;
};

export default LastLoginNotice;
